import $ from 'jquery';
const SELECTOR = '.logo-grid';

function onDocumentReady() {
	$(SELECTOR).on('click', '.view-more', onClickViewMore);
}

function onClickViewMore(e) {
	const clicked = $(e.currentTarget);

	if (clicked.text() === 'View More +') {
		clicked.text('View Less –');
	} else {
		clicked.text('View More +');
	}

	clicked.closest(SELECTOR).find('.logo:nth-child(n + 11)').slideToggle();
}

document.addEventListener('DOMContentLoaded', onDocumentReady);
